// Bundle theme module
import NSTheme from './NSTheme';
import Helper from './Classes/Helper';
import FocusHandler from './Classes/FocusHandler';
import LazyLoad from './Classes/Lazyload';
import ResponsiveTable from "./Classes/ResponsiveTable";
import Accordion from './Classes/Accordion';
import CV from './Classes/CV';
import Header from './Classes/Header';
import Dropdowntoggler from './Classes/Dropdowntoggler';
import BackToTop from "./Classes/BackToTop";
import GoToNextSection from "./Classes/goToNextSection";
import countUpNumbers from './Classes/countUpNumbers';
import XDownloader from './Classes/XDownloader';
import Animate from './Classes/Animate';

// import Jump from './Classes/Jump'
// import Sticky from '../../node_modules/sticky-js';

export default NSTheme;

(function () {
  document.addEventListener('DOMContentLoaded', () => {

    new Animate();

    new XDownloader({
      downloadText: "XLSX Download", //Can be empty if you want to use an icon instead
      backgroundColor: "CACDCD", //Colored Cells Background
      backgroundClass: 'ns-backgroundcolor-hintergrund', //Class of colored cells
      borderColor: '979797', //Color of border
      borderColor2: '979797',
      borderStyle: 'thin', // thin/dotted/medium/double/thick
      borderStyle2: 'thin', // thin/dotted/medium/double/thick
      headClass: 'head', //Class you want your columns based on. Will be bold in Excel
      boldClass: 'line_bold', //Class for Bold text in Excel
      boldClass2: 'bline_bold', //Class for Bold text in Excel
      boldClass3: 'bold', //Class for Bold text in Excel
      borderClass: 'ns-borderbottom-fein',
      borderClass2: 'ns-borderbottom-fett'
    });

    new FocusHandler();

    new LazyLoad();

    new Header({
      mobileNavToggleSelector: '.js-toggle-main-menu',
      mainMenuContainerSelector: '.header__menu',
      submenuToggleSelector: '.js-nav-dropdown-toggler',
      submenuBackToggleSelector: '.js-menu-item-back',
      searchOpenSelector: '.js-search-trigger',
      searchCloseSelector: '.js-search-close',
    });

    new Dropdowntoggler({
      dropdownWrapperSelector: '.js-dropdown-wrapper',
      dropdownToggleSelector: '.js-dropdown-toggle',
      dropdownDropSelector: '.js-dropdown',
      needsBackdrop: true
    });

    new Dropdowntoggler({
      dropdownWrapperSelector: '.js-footer-dropdown-wrapper',
      dropdownToggleSelector: '.js-footer-dropdown-toggle',
      dropdownDropSelector: '.js-footer-dropdown',
      needsBackdrop: false
    });

    new ResponsiveTable({
      tableSelector: '.ns-table-wrap table',
      tableWrapperSelector: '.ns-table-wrap',
      breakPointLg: 1200,
      breakPointMd: 768,
      breakPointSm: 480,
      colCountNoSplit: 2,
      colCountEarlyBreak: 7,
      noSplitArray: []
    });

    new BackToTop({
      buttonClass: '.js-backtotop-toggle',
      stickyClass: '.prev-next__inner',
      fadeInPosition: 500,
      correction: 121
    });

    // new Jump({
      //   graphicSelector: '.ns-graphic'
      // });

    new Accordion({
      accordions: '.js-accordion-trigger'
    });

    new CV({
      trigger: '.js-text-trigger'
    });


    new GoToNextSection({
      button: '.ns-header-image__btn-goto-next-section',
      parent: '.ns-header-image'
    });

    new countUpNumbers({
      numbers: '.ns-keyfigures__number',
      numbersWrapper: 'ns-keyfigures', //add classname without point in front
      classIn: 'is-in-viewport',
      classOut: 'is-not-in-viewport',
      decimalEN: '.',
      decimalDE: ',',
      decimalFR: ',',
      separatorEN: ',',
      separatorDE: ' ',
      separatorFR: ' '
    });

  })
})();
